/* ============================================================================
   LAH — BRINDE TRAVEL CASE NA TERCEIRA COMPRA
   Tema: Outubro (Claude 8.0)

   O e-mail leva a /discount/BRINDETRAVELCASE. A Shopify grava o codigo e
   manda o cliente para a loja. A partir dai, dois comportamentos:

   ============================================================================
   GRAU OU SOL — a condicao e "OU"
   ============================================================================
   Vale oculos de grau com lente de grau OU oculos de sol com lente solar de
   grau. Por isso:
     - o pop-up oferece as DUAS colecoes, sem empurrar o cliente para uma;
     - a lista de lentes que dispara o brinde inclui as solares com grau.

   No desconto da Shopify, o "OU" sai de graca: com varias colecoes no
   "Compre", qualquer item de qualquer uma soma para o minimo.

   ============================================================================
   1. POP-UP DE RESGATE
   ============================================================================
   Na chegada, um pop-up confirma o brinde e explica a condicao.

   COMO SABEMOS QUE O CLIENTE VEIO DO LINK: a Shopify grava o codigo no cookie
   discount_code. Lemos esse cookie e tambem os codigos do carrinho. Nao
   dependemos de parametro na URL, porque o link /discount/ redireciona sem
   carregar nenhum.

   Aparece uma vez a cada 24 horas por navegador.

   ============================================================================
   2. O TRAVEL CASE ENTRA NO CARRINHO SOZINHO
   ============================================================================
   Desconto da Shopify torna o item gratis, mas NAO o coloca no carrinho.

   Quando o codigo esta ativo e o carrinho tem lente de grau (de grau ou solar
   com grau) e atinge o minimo, o case e adicionado com a marca _lah_brinde.
   Depois CONFERIMOS O PRECO: se o case nao saiu por R$ 0, o desconto nao
   aplicou e o case e removido. O cliente nunca paga por um brinde.

   A EXIGENCIA DE LENTE COM GRAU VIVE SO AQUI. A colecao "Lentes Grau" da loja
   tambem guarda lentes SEM grau (Polarizada, por exemplo), entao a Shopify
   nao distingue. Este script so adiciona o case quando ha lente com grau.

   SEM LACO: cada estado do carrinho e tentado uma unica vez, guardado na
   sessao. Isso impede o ciclo adicionar, remover, recarregar — e respeita
   quem removeu o case de proposito.

   Se o cliente tirar a lente ou cair abaixo do minimo, o case marcado sai.
   Um Travel Case adicionado a mao, sem a marca, nunca e tocado.

   ============================================================================
   LENTES COM GRAU — mesma lista da barreira de compra. Se uma lente nova com
   grau for criada, o titulo dela entra aqui tambem.
   ============================================================================ */

(function () {
    'use strict';

    var CFG = window.LAH_BRINDE || {};
    if (!CFG.ativo) return;

    var CODIGO = (CFG.codigo || 'BRINDETRAVELCASE').toUpperCase();
    var HANDLE = CFG.handle || 'lahtref-travel-case';
    var MINIMO = parseInt(CFG.minimo, 10) || 50000;
    var COLECAO_GRAU = CFG.colecaoGrau || '/collections/oculos-de-grau';
    var COLECAO_SOL = CFG.colecaoSol || '/collections/oculos-de-sol';
    var VALIDADE = CFG.validade || '';

    var CHAVE_POPUP = 'lah_brinde_popup';
    var CHAVE_TENTATIVA = 'lah_brinde_tentativa';
    var MARCA = '_lah_brinde';

    var GRAU = [
        'normal', 'fina', 'super fina',
        'base', 'amplo', 'dinamico',
        'multifocal normal', 'multifocal fina', 'multifocal super fina',
        'solar normal', 'solar fina', 'solar super fina',
        'solar base', 'solar amplo', 'solar dinamico',
        'solar classica com grau'
    ];

    function normalize(t) {
        return (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    function track(ev, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: ev }, dados || {}));
        } catch (e) {}
    }

    function lerCookie(nome) {
        var m = document.cookie.match('(?:^|; )' + nome + '=([^;]*)');
        return m ? decodeURIComponent(m[1]) : '';
    }

    function codigoNoCookie() {
        return lerCookie('discount_code').toUpperCase().split(',').indexOf(CODIGO) !== -1;
    }

    function codigoNoCarrinho(cart) {
        return (cart.discount_codes || []).some(function (d) {
            return (d.code || '').toUpperCase() === CODIGO;
        });
    }

    function sessao(chave, valor) {
        try {
            if (valor === undefined) return sessionStorage.getItem(chave);
            sessionStorage.setItem(chave, valor);
        } catch (e) { return null; }
    }

    /* ---------------------------------------------------------------------
       ESTILO
       --------------------------------------------------------------------- */
    var estilo = document.createElement('style');
    estilo.textContent =
        '.lah-br{position:fixed;inset:0;z-index:2147482000;display:flex;align-items:center;' +
        'justify-content:center;padding:20px;background:rgba(10,14,12,.6);' +
        '-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);}' +
        '.lah-br__cx{position:relative;background:#fff;color:#111;border-radius:18px;' +
        'max-width:400px;width:100%;overflow:hidden;box-shadow:0 24px 60px rgba(0,0,0,.3);text-align:center;}' +
        '.lah-br__img{display:block;width:100%;aspect-ratio:4/3;object-fit:cover;background:#F2F2F1;}' +
        '.lah-br__corpo{padding:22px 22px 20px;}' +
        '.lah-br__selo{display:inline-block;font-size:11px;letter-spacing:.14em;text-transform:uppercase;' +
        'background:#111;color:#fff;border-radius:999px;padding:4px 10px;margin-bottom:12px;}' +
        '.lah-br__t{font-size:22px;font-weight:600;line-height:1.2;margin:0 0 8px;}' +
        '.lah-br__p{font-size:15px;line-height:1.5;opacity:.75;margin:0 0 14px;}' +
        '.lah-br__cond{font-size:12px;line-height:1.4;opacity:.6;margin:0 0 18px;}' +
        '.lah-br__ctas{display:grid;grid-template-columns:1fr 1fr;gap:8px;}' +
        '.lah-br__cta{display:block;background:#000;color:#fff;border:1px solid #000;border-radius:999px;' +
        'padding:14px 10px;font:inherit;font-size:14px;font-weight:600;text-decoration:none;cursor:pointer;}' +
        '.lah-br__cta--sec{background:#fff;color:#000;}' +
        '.lah-br__sair{display:block;width:100%;background:none;border:0;margin-top:12px;' +
        'font:inherit;font-size:13px;color:#777;cursor:pointer;}' +
        '.lah-br__x{position:absolute;top:10px;right:10px;width:34px;height:34px;border-radius:50%;' +
        'border:0;background:rgba(255,255,255,.9);font-size:20px;line-height:1;cursor:pointer;}' +
        '.lah-br-aviso{position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(12px);' +
        'z-index:2147482001;background:#111;color:#fff;border-radius:12px;padding:13px 18px;' +
        'font-size:14px;line-height:1.4;max-width:min(92vw,420px);text-align:center;' +
        'box-shadow:0 12px 30px rgba(0,0,0,.3);opacity:0;transition:opacity .3s ease,transform .3s ease;}' +
        '.lah-br-aviso.is-on{opacity:1;transform:translateX(-50%) translateY(0);}' +
        '@media (max-width:360px){.lah-br__ctas{grid-template-columns:1fr;}}';
    document.head.appendChild(estilo);

    function aviso(texto) {
        var el = document.createElement('div');
        el.className = 'lah-br-aviso';
        el.setAttribute('role', 'status');
        el.textContent = texto;
        document.body.appendChild(el);
        requestAnimationFrame(function () { el.classList.add('is-on'); });
        setTimeout(function () {
            el.classList.remove('is-on');
            setTimeout(function () { el.remove(); }, 400);
        }, 5000);
    }

    /* ---------------------------------------------------------------------
       PRODUTO — variante e foto lidas da propria loja, nada fixo no codigo
       --------------------------------------------------------------------- */
    var produto = null;

    function carregarProduto() {
        if (produto) return Promise.resolve(produto);

        return fetch('/products/' + HANDLE + '.js')
            .then(function (r) { return r.json(); })
            .then(function (p) {
                var v = p.variants && p.variants[0];
                produto = {
                    id: v ? v.id : null,
                    disponivel: v ? v.available : false,
                    imagem: p.featured_image || '',
                    titulo: p.title || 'Travel Case'
                };
                return produto;
            });
    }

    function moeda(centavos) {
        return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
    }

    /* ---------------------------------------------------------------------
       1. POP-UP DE RESGATE — as duas colecoes, sem empurrar para uma
       --------------------------------------------------------------------- */
    function popupVistoRecente() {
        try {
            var t = parseInt(localStorage.getItem(CHAVE_POPUP), 10);
            return t && (Date.now() - t) < 24 * 60 * 60 * 1000;
        } catch (e) { return false; }
    }

    function abrirPopup() {
        try { localStorage.setItem(CHAVE_POPUP, String(Date.now())); } catch (e) {}

        carregarProduto().catch(function () { return null; }).then(function (p) {
            var img = p && p.imagem ? p.imagem : '';
            if (img && img.indexOf('//') === 0) img = 'https:' + img;

            var cond = 'Em pedidos a partir de ' + moeda(MINIMO) + ' com lentes de grau. Um por cliente' +
                (VALIDADE ? ', até ' + VALIDADE : '') + '.';

            var painel = document.createElement('div');
            painel.className = 'lah-br';
            painel.setAttribute('role', 'dialog');
            painel.setAttribute('aria-modal', 'true');
            painel.setAttribute('aria-label', 'Seu brinde Travel Case');

            painel.innerHTML =
                '<div class="lah-br__cx">' +
                '<button type="button" class="lah-br__x" data-br-fechar aria-label="Fechar">&times;</button>' +
                (img ? '<img class="lah-br__img" src="' + img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=800" alt="Travel Case Lahtref">' : '') +
                '<div class="lah-br__corpo">' +
                '<span class="lah-br__selo">Presente para você</span>' +
                '<p class="lah-br__t">Seu Travel Case está reservado</p>' +
                '<p class="lah-br__p">Escolha seu próximo Lahtref, de grau ou de sol, com lentes de grau. O Travel Case, que guarda até 3 óculos, entra no seu carrinho como presente.</p>' +
                '<p class="lah-br__cond">' + cond + '</p>' +
                '<div class="lah-br__ctas">' +
                '<a class="lah-br__cta" href="' + COLECAO_GRAU + '" data-br-ir="grau">Óculos de grau</a>' +
                '<a class="lah-br__cta lah-br__cta--sec" href="' + COLECAO_SOL + '" data-br-ir="sol">Óculos de sol</a>' +
                '</div>' +
                '<button type="button" class="lah-br__sair" data-br-fechar>Agora não</button>' +
                '</div></div>';

            document.body.appendChild(painel);
            track('lah_brinde_popup', {});

            painel.addEventListener('click', function (e) {
                var ir = e.target.closest('[data-br-ir]');
                if (ir) {
                    track('lah_brinde_popup_cta', { destino: ir.getAttribute('data-br-ir') });
                    return; /* o link segue sozinho */
                }
                if (e.target.closest('[data-br-fechar]') || e.target === painel) {
                    painel.remove();
                }
            });
        });
    }

    /* ---------------------------------------------------------------------
       2. ADICAO AUTOMATICA — ver a nota no topo
       --------------------------------------------------------------------- */
    var ocupado = false;

    function atualizarTela() {
        try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (e) {}

        if (window.location.pathname.replace(/\/$/, '') === '/cart') {
            window.location.reload();
        }
    }

    function remover(chave) {
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: chave, quantity: 0 })
        });
    }

    function linhaDoBrinde(cart) {
        for (var i = 0; i < cart.items.length; i++) {
            var it = cart.items[i];
            if (it.properties && it.properties[MARCA]) return it;
        }
        return null;
    }

    function temLenteDeGrau(cart) {
        return cart.items.some(function (it) {
            return normalize(it.product_type) === 'lentes para oculos' &&
                GRAU.indexOf(normalize(it.product_title)) !== -1;
        });
    }

    function avaliar() {
        if (ocupado) return;
        ocupado = true;

        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                if (!codigoNoCarrinho(cart) && !codigoNoCookie()) return;

                var brinde = linhaDoBrinde(cart);
                var subtotal = cart.items_subtotal_price - (brinde ? brinde.final_line_price : 0);
                var elegivel = temLenteDeGrau(cart) && subtotal >= MINIMO;

                /* Ja existe: sai se perdeu a condicao ou se nao esta gratis. */
                if (brinde) {
                    if (!elegivel || brinde.final_line_price > 0) {
                        return remover(brinde.key).then(function () {
                            track('lah_brinde_removido', { motivo: elegivel ? 'nao_gratis' : 'condicao' });
                            atualizarTela();
                        });
                    }
                    return;
                }

                if (!elegivel) return;

                /* Cada estado do carrinho e tentado uma vez — ver SEM LACO. */
                var assinatura = cart.token + ':' + cart.item_count + ':' + cart.items_subtotal_price;
                if (sessao(CHAVE_TENTATIVA) === assinatura) return;
                sessao(CHAVE_TENTATIVA, assinatura);

                return carregarProduto().then(function (p) {
                    if (!p.id || !p.disponivel) {
                        track('lah_brinde_sem_estoque', {});
                        return;
                    }

                    var itens = [{ id: p.id, quantity: 1, properties: {} }];
                    itens[0].properties[MARCA] = 'travel-case';

                    return fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ items: itens })
                    })
                    .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
                    .then(function (c2) {
                        var linha = linhaDoBrinde(c2);
                        if (!linha) return;

                        /* A Shopify decide: so fica se saiu por R$ 0. */
                        if (linha.final_line_price > 0) {
                            return remover(linha.key).then(function () {
                                track('lah_brinde_nao_aplicou', {});
                                atualizarTela();
                            });
                        }

                        track('lah_brinde_adicionado', {});
                        aviso('Travel Case adicionado ao seu carrinho como presente.');
                        atualizarTela();
                    });
                });
            })
            .catch(function () { /* erro nunca mexe no carrinho */ })
            .then(function () { ocupado = false; });
    }

    /* ---------------------------------------------------------------------
       QUANDO RODAR
       --------------------------------------------------------------------- */
    function iniciar() {
        if (codigoNoCookie() && !popupVistoRecente()) {
            abrirPopup();
        }

        /* O configurador de lentes leva ao carrinho depois de adicionar: o
           carregamento da pagina ja cobre o caminho principal. */
        avaliar();
    }

    ['cart:change', 'cart:updated'].forEach(function (ev) {
        document.addEventListener(ev, function () { setTimeout(avaliar, 300); });
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', iniciar);
    } else {
        iniciar();
    }
})();
